import { type MapState, type SetSwitchProps, type SetCounterProps, type SetVariableProps, type MapDispatchProps, type SetEnvironmentGridProps, type SetDayLightGridProps, type SetNightLightGridProps, type SetLightGridProps, type LoadMapProps, type SetPlayerPositionProps, type TravelProps, type startPlayerMovementProps } from 'src/types'
import { defaultMapState } from './defaults'

const setSwitch = (state: MapState, { switchID, boolean }: SetSwitchProps) => ({
  ...state,
  switches: {
    ...state.switches,
    [switchID]: boolean
  }
})

const setCounter = (state: MapState, { counterID, counterEffect }: SetCounterProps) => {
  const key = Object.keys(counterEffect)[0]

  // this checks if the value is sourced directly or from an existing variable

  // @ts-expect-error
  const value = counterEffect[key]

  const count: number = typeof value === 'number' ? value : Number(value) ? Number(value) : state.counters[value] || 0
  return {
    ...state,
    counters: {
      ...state.counters,
      [counterID]: (
        key === '='
          ? count
          : key === '+'
            ? (state.counters[counterID] || 0) + count
            : key === '-' && (state.counters[counterID] || 0) - count < 0 && counterID !== 'karma'
              ? 0
              : key === '-'
                ? (state.counters[counterID] || 0) - count
                : state.counters[counterID]
      )
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const setPlayerPosition = (state: MapState, {player_y, player_x}: SetPlayerPositionProps) => state.switches.movement_blocked ? state : (
  {
    ...state,
    counters: {
      ...state.counters,
      player_y,
      player_x
    }
  }
)

// eslint-disable-next-line @typescript-eslint/naming-convention
const travel = (state: MapState, {player_y, player_x, location_id}: TravelProps) => (
  {
    ...state,
    switches: {
      ...state.switches,
      game_started: false,
      map_loaded: false,
      movement_blocked: true
    },
    counters: {
      ...state.counters,
      player_y,
      player_x
    },
    variables: {
      ...state.variables,
      location_id
    }
  }
)

const setVariable = (state: MapState, { variableID, string }: SetVariableProps) => (
  {
    ...state,
    variables: {
      ...state.variables,
      [variableID]: string
    }
  }
)

const setEnvironmentGrid = (state: MapState, { contentGrid }: SetEnvironmentGridProps) => (
  {
    ...state,
    contentGrid
  }
)

const setLightGrid = (state: MapState, { lightGrid }: SetLightGridProps) => (
  {
    ...state,
    lightGrid: JSON.parse(JSON.stringify(lightGrid))
  }
)

const resetMap = (state: MapState) => (
  {
    ...defaultMapState,
    switches: {
      ...defaultMapState.switches,
      api_data_loaded: state.switches.api_data_loaded
    }
  }
)

// eslint-disable-next-line @typescript-eslint/naming-convention
const loadMap = (state: MapState, { contentGrid, lightGrid}: LoadMapProps) => (
  {
    ...state,
    switches: {
      ...state.switches,
      map_loaded: true,
      movement_blocked: false
    },
    contentGrid,
    lightGrid
  }
)


export const reducer = (state: MapState, action: MapDispatchProps) => {
  switch (action.type) {
    case 'SET_COUNTER':
      return setCounter(state, action)
    case 'SET_VARIABLE':
      return setVariable(state, action)
    case 'SET_SWITCH':
      return setSwitch(state, action)
    case 'SET_PLAYER_POSITION':
      return setPlayerPosition(state, action)
    case 'SET_ENVIRONMENT_GRID':
      return setEnvironmentGrid(state, action)
    case 'SET_LIGHT_GRID':
      return setLightGrid(state, action)
    case 'LOAD_MAP':
      return loadMap(state, action)
    case 'RESET_MAP':
      return resetMap(state)
    case 'TRAVEL':
      return travel(state, action)
    default:
      return state
  }
}
